import React from "react";
import { useTranslation } from "react-i18next";
import { useDuplicateList } from "@planzone/view-models";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { ListsList } from "./listsList";
import { Props } from "./types";
import styles from "./styles.scss";

function ListDuplication({ list, rank, cancel }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, duplicateList } = useDuplicateList(list);

  return (
    <Modal
      header={t("duplicateList.title", { name: list.name })}
      close={cancel}
    >
      <form
        className={styles.listDuplication}
        onSubmit={(e) => {
          e.preventDefault();

          !isRequestPending && duplicateList({ list, rank });
        }}
      >
        <p className={styles.message}>{t("duplicateList.message")}</p>
        <div className={styles.form}>
          <ListsList list={list} />
        </div>
        <div className={styles.footer}>
          <Button type="cancel" press={cancel}>
            {t("duplicateList.cancel")}
          </Button>
          <Button
            type="submit"
            status={isRequestPending ? "pending" : "none"}
            isDisabled={isRequestPending}
          >
            {t("duplicateList.submit")}
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export { ListDuplication };
